/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/jsx-no-useless-fragment */

import { useForm } from "react-hook-form";
import { useNavigate, useParams } from "react-router-dom";
import {
  Form,
  FormField,
  FormControl,
  FormItem,
  Card,
  CardHeader,
  CardTitle,
  CardContent,
  Textarea,
} from "@repo/ui";
import FormInput from "ui/Input";
import { PATHS } from "routes/paths";
import FormSelect from "ui/select";
import Loader from "ui/page-loader";
import { Label } from "ui/label";
import { LEAD_NOTES, PRIORITIES_LIST } from "../constants";
import {
  useCreateCall,
  useGetTicketDetails,
  useSaveCall,
  useSubmitTicket,
} from "services/tickets";
import { useEffect, useState } from "react";
import { useLookupCustomers, useLookupGetRegion } from "services/lookups";
import { TicketCreateHeader } from "components/tickets/ticket-create-header";

const emptyTicket = {
  createdBy: "",
  priority: "Normal",
  reportedBy: "",
  leadNotes: "",
  requesterEmail: "",
  region: "",
  requesterContactNo: "",
  companyName: "",
  remarks: "",
};
export default function CreateMarketingTicket() {
  const [ticketDetails, setTicketDetails] = useState("");
  const params = useParams();
  const navigate = useNavigate();
  const form = useForm({
    defaultValues: { ...emptyTicket },
  });

  const generalProps = { errors: form.formState.errors, control: form.control };
  const verificationRules = {
    reportedBy: { required: "Please Enter Value" },
    requesterEmail: { required: "Please Enter Value" },
    requesterContact: { required: "Please Enter Value" },
    priority: { required: "Please Select Value" },
    region: { required: "Please Select Value" },
    companyName: { required: "Please Enter Value" },
    leadNotes: { required: "Please Enter Value" },
    remarks: { required: "Please Enter Value" },
  };
  const {
    mutate: getRegion,
    data: regionsListRes,
    isPending: gettingRegionsList,
  } = useLookupGetRegion();
  const {
    mutate: getTicket,
    data: ticketDetailsRes,
    isPending: gettingTicket,
    reset: resetDetailsApi,
  } = useGetTicketDetails();
  const {
    mutate: createTicket,
    data: createTicketRes,
    isPending: creatingTicket,
    error: createTicketError,
    reset: resetCreateTicket,
  } = useCreateCall();
  const {
    mutate: saveTicket,
    data: saveTicketRes,
    isPending: savingTicket,
    error: saveTicketError,
    reset: resetSaveTicket,
  } = useSaveCall();
  const {
    mutate: submitTicket,
    data: submitTicketRes,
    isPending: submittingTicket,
    error: submitTicketError,
    reset: resetSubmitTicket,
  } = useSubmitTicket();
  const { mutate: getCustomersList, data: customersListRes } =
    useLookupCustomers();
  useEffect(() => {
    getRegion("UAE");
    getCustomersList();
    if (params.ticketId) {
      getTicket(params.ticketId);
    }
  }, []);
  useEffect(() => {
    if (ticketDetailsRes) {
      const _details = {
        ...ticketDetailsRes.data,

        isCustomerComplaint: ticketDetailsRes.data.isCustomerComplaint
          ? "Yes"
          : "No",
      };
      const _ticket = { ...emptyTicket, region: _details.state, ..._details };
      form.reset({ ..._ticket });
      setTicketDetails({ ..._ticket });
      resetDetailsApi();
    }

    if (createTicketRes) {
      resetCreateTicket();
      navigate(PATHS.allServiceAndNonServiceCalls);
      form.reset();
    }
    if (createTicketError) {
      resetCreateTicket();
    }
    if (saveTicketRes) {
      resetSaveTicket();
      navigate(PATHS.allServiceAndNonServiceCalls);
      form.reset();
    }
    if (saveTicketError) {
      resetSaveTicket();
    }

    if (submitTicketRes) {
      resetSubmitTicket();
      navigate(PATHS.allServiceAndNonServiceCalls);
      form.reset({ ...emptyTicket });
    }
    if (submitTicketError) {
      resetSubmitTicket();
    }
  }, [
    createTicketRes,
    createTicketError,
    saveTicketRes,
    saveTicketError,
    ticketDetailsRes,
    submitTicketError,
    submitTicketRes,
  ]);
  const createTicketPayload = () => {
    const _data = form.getValues();
    const customer = customersListRes?.data.find(
      (elm) => elm.name === "Transguard Group (TG)"
    );
    const payload = {
      customerId: customer?.customerId || "",
      reportedBy: _data.reportedBy,
      priority: _data.priority
        ? PRIORITIES_LIST.filter((elm) => elm.id === _data.priority)[0].value
        : "",
      remarks: _data.remarks,
      region: _data.region,
      requesterEmail: _data.requesterEmail,
      requesterContactNo: _data.requesterContactNo,
      leadNotes: _data.leadNotes,
      companyName: _data.companyName,
      activityType: "Marketing",
      category: "Marketing",
      subCategory: "Marketing",
      assignmentGroup: "Marketing",
      creationChannel: "Web",

      isChargeable: false,
      isCustomerComplaint: false,
      billingCharges: false,
      correlationId: "",
    };
    return payload;
  };
  const onSubmit = () => {
    const _data = form.getValues();
    const payload = {
      ticketId: _data.ticketId,
      ...createTicketPayload(),
    };
    submitTicket({ ...payload });
  };
  const onCancel = () => {};
  const onReset = () => {
    form.reset({ ...ticketDetails });
  };

  const onSave = () => {
    createTicket(createTicketPayload());
  };

  const onSaveAsDraft = () => {
    const payload = createTicketPayload();
    saveTicket({ ...payload });
  };
  return (
    <>
      {savingTicket ||
      creatingTicket ||
      gettingTicket ||
      submittingTicket ||
      gettingRegionsList ? (
        <Loader />
      ) : (
        <></>
      )}

      <div className="form-container">
        <TicketCreateHeader
          isDraft={form.watch("status") === "Draft"}
          onSaveAsDraft={form.handleSubmit(onSaveAsDraft)}
          onSubmit={form.handleSubmit(onSubmit)}
          onSave={form.handleSubmit(onSave)}
          onReset={onReset}
          onCancel={oncancel}
        />

        <Card className="form-card shadow-lg mx-0">
          <CardHeader>
            <CardTitle>Marketing</CardTitle>
          </CardHeader>
          <Form {...form}>
            <form
              // onSubmit={form.handleSubmit(onSubmit)}
              className="space-y-8 custom-form-v2"
            >
              <CardContent className="w-full flex flex-row items-center justify-between flex-wrap gap-4">
                <div className="form-row-d-50">
                  <FormInput
                    {...generalProps}
                    name="reportedBy"
                    label="Requested By"
                    inputProps={{ autoFocus: true }}
                    isRequired
                    rules={verificationRules.reportedBy}
                  />

                  <FormSelect
                    {...generalProps}
                    name="priority"
                    label="Priority"
                    placeholder="Select Priority"
                    data={PRIORITIES_LIST}
                    id="id"
                    text="text"
                    isRequired
                    rules={verificationRules.priority}
                  />
                  <FormInput
                    {...generalProps}
                    name="requesterEmail"
                    label="Requester Email ID"
                    isRequired
                    rules={verificationRules.requesterEmail}
                  />
                  <FormSelect
                    {...generalProps}
                    isRequired
                    name="leadNotes"
                    label="Lead Notes"
                    placeholder="Select Lead Notes"
                    data={LEAD_NOTES}
                    id="id"
                    text="text"
                    rules={verificationRules.leadNotes}
                  />
                  <FormInput
                    {...generalProps}
                    name="requesterContactNo"
                    label="Requester Contact No"
                    rules={verificationRules.requesterContact}
                  />

                  <FormSelect
                    {...generalProps}
                    isRequired
                    name="region"
                    label="Region"
                    placeholder="Select Region"
                    data={regionsListRes?.data || []}
                    id="name"
                    text="name"
                    rules={verificationRules.region}
                  />
                  <FormInput
                    {...generalProps}
                    name="companyName"
                    label="Company Name"
                    isRequired
                    rules={verificationRules.companyName}
                  />
                </div>
                <div className="flex flex-col gap-inherit w-full mt-6">
                  <FormField
                    control={form.control}
                    name="remarks"
                    rules={verificationRules.remarks}
                    render={({ field }) => (
                      <FormItem>
                        <div className="flex flex-col gap-6 w-full">
                          <Label
                            label="Purpose of Call"
                            isRequired
                            style={{
                              justifyContent: "flex-start",
                              textAlign: "left",
                            }}
                          />

                          <div>
                            <FormControl>
                              <Textarea
                                {...field}
                                className="min-w-full"
                                style={
                                  form.formState?.errors?.remarks
                                    ? {
                                        borderColor: "red",
                                      }
                                    : {}
                                }
                              />
                            </FormControl>
                            {form.formState?.errors &&
                            form.formState?.errors.remarks ? (
                              <p className="text-destructive text-xs">
                                {form.formState.errors.remarks.message}
                              </p>
                            ) : (
                              <></>
                            )}
                          </div>
                        </div>
                      </FormItem>
                    )}
                  />
                </div>
              </CardContent>
            </form>
          </Form>
        </Card>
      </div>
    </>
  );
}
